import { render, staticRenderFns } from "./TeamAdd.vue?vue&type=template&id=21ac9a08"
import script from "./TeamAdd.vue?vue&type=script&lang=js"
export * from "./TeamAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports